<template>
  <myhead :value="value" @next="next" @lookmore="more">{{
$route.query.title || $route.meta.title
}}</myhead>
  <van-empty description="暂无数据" v-if="list.length==0" />
  <div ref="wrapper" class="scroll" v-else style="height:calc(100vh - 45px)" @scroll.passive="isScrollBottom">
    <div class="pad15 size14">
      <div v-for="item,index in list" :key="index" class="BGwhite mb15 radius8 pad14" @click="toDetail(item.thumb,item.apply_message)">
        <div class="flex start nowrap relative">
          <div class="absolute t BGon Cfff size12 opacity7" style="padding:1px 5px;left:-2px;border-radius:0 0 10px 0;">{{item.cate_name}}</div>
          <img :onerror="imgError" :src="item.pic || img" class="width80px height80px BGf0 radius5" alt="" />
          <div class="ml15 flex1">
            <div class="size16 flex between nowrap mb8">
              <p class="ellipsis" style="width: 160px;word-break: break-all">{{item.name}}</p>
              <span class="Con size16 b500">{{item.salary}}</span>
            </div>
            <p class="BGf8 radius10 C999 size12 line20 text" style="padding:0 10px;word-break: break-all">简介：{{item.description}}</p>
          </div>
        </div>
        <div class="flex between mt10">
          <p class="C999 size14 flex">
            <!-- <img src="@/assets/img/icon25.png" class="height20px mr5 opacity7" alt="">  -->
            {{item.add_time}}
          </p>
          <p class="flex C888 size14">
            <img src="@/assets/img/icon1.png" class="filterGray mr5 opacity4 height20px" alt="">{{item.browse}}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import img from '@/assets/img/empty.png';
export default {
  data () {
    return {
      img,
      list: []
    }
  },
  methods: {
    toDetail (src, msg) {
      if (src) {
        this.$router.push({ path: '/recruit/detail', query: { src } })
      } else {
        this.showToast(msg)
      }
    },
    getList (page) {
      this.page = page || this.page;
      let list = this.list;
      if (this.page > 1) {
        if (this.page > this.count) {
          return this.page = this.count;
        }
      } else {
        list = [];
      }
      this.ajax.post("users/getrecruitlist", { page: this.page }).then(({ data, count }) => {
        this.list = list.concat(data);
        this.count = count;
      }).finally(() => {
        this.isLoading = false;
      })
    },
    isScrollBottom () {
      // 是否滚动到了底部
      this.box = this.$refs.wrapper
      var clientHeight = this.box.clientHeight
      var scrollTop = this.box.scrollTop
      var scrollHeight = this.box.scrollHeight
      if (scrollTop + clientHeight == scrollHeight) {
        this.getList(this.page + 1);
      }
    },
    next () {
      history.forward()
    },
  },
  created () {
    this.getList();
  }
}
</script>
<style scoped>
.text{
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    display: -moz-box;
    -moz-line-clamp: 2;
    -moz-box-orient: vertical;
    overflow-wrap: break-word;
    word-break: break-all;
    white-space: normal;
    overflow: hidden;
}
</style>